export default __webpack_public_path__ + "static/media/icon-timbrado.1b1e09e7.svg";